import styled from 'styled-components';

const Strapline = styled.div`
  text-align: left;
  margin-top: 0;
`;

export default Strapline;
